import React, { useEffect, useRef } from 'react'
import * as d3 from 'd3'
import { Row, Col, Modal, Button } from 'antd'
import LineGraph from '../graph/linegraph'
import Device from '../../services/device.service'
import moment from 'moment'
import _ from 'lodash'
import { CHART_COLORS } from '../../util/chartPalette'
var device = new Device()

const PatientBar = (props) => {
  const ref = useRef(null)
  var dataWithDate = {
    _id: '1',
    xAxisLable: 'date',
    yAxisLable: 'mm-gg',
    devicename: 'Device name',
    yAxisRange: { min: 0, max: 20 },
    data: [
      {
        reading: 'Dystolic',
        threshold: { min: 2, max: 16 },
        values: [
          { x: '2018-04-13', y: [5, 2] },
          { x: '2018-04-14', y: [6, 3] },
          { x: '2018-04-15', y: [1, 8] },
          { x: '2018-04-16', y: [2, 4] },
          { x: '2018-04-17', y: [2, 15] },
        ],
      },
    ],
  }

  const handleclick = async (e) => {
    e.stopPropagation()
    let graphData = await device.getGraphMeasurementData(
      props.pid,
      props.data._id
    )

    //   return ( <Modal
    //     className={"filterModal"}
    //     closable={false}
    //     visible={openGraph}
    //     onOk={onOk}
    //     maskClosable={false}
    //     width={"70%"}
    // >
    //     <LineGraph identifier={props.data.device_name} data={dataWithDate}/>
    // </Modal>)
    Modal.confirm({
      title: 'Measurement Chart',
      centered: true,
      okText: 'Close',
      content: (
        <div>
          {graphData.data ? (
            graphData.data.map((d, i) => (
              <LineGraph data={{ ...d, _id: d._id + '' + i }} />
            ))
          ) : (
            <>NA</>
          )}
        </div>
      ),
      cancelButtonProps: { hidden: 'true' },
      icon: false,
      width: 600,
      /*bodyStyle:{
                backgroundColor:'white',
                width:"300px",
                height:"400px"},
                style:{
                     backgroundColor:'white',
                maxWidth:"300px",
                height:"400px"
                }*/
    })
  }
  useEffect(() => {
    drawbarcharts()
  })

  var drawbarcharts = () => {
    // d3.select("#bargroup"+props.data._id).remove();
    let svg = d3.select(ref.current)
    let count = props.data.devicesummary
    var label = ['complete', 'partial', 'incomplete', 'remaining']
    var data = [
      count?.completeddays,
      count?.partialdays,
      count?.incompletedays,
      count?.remainingdays,
    ]
    // var data = [22,5,8,10]
    var width = svg.attr('width')
    var height = svg.attr('height')
    var radius = Math.min(width, height) / 2
    var g = svg
      .append('g')
      .attr('id', 'bargroup' + props.data._id)
      .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')')
    var color = d3.scaleOrdinal([
      CHART_COLORS.completeGreenSoft,
      CHART_COLORS.partialYellow,
      CHART_COLORS.skippedRed,
      CHART_COLORS.remainingGray,
    ])
    var pie = d3.pie()

    var arc2 = d3.arc().innerRadius(0).outerRadius(radius)
    var arcs2 = g
      .selectAll('arc2')
      .data(pie(data))
      .enter()
      .append('g')
      .attr('stroke', 'white')
      .attr('stroke-width', '0')
      .attr('class', 'arc2')
    arcs2
      .append('path')
      .attr('fill', function (d, i) {
        return color(i)
      })
      .attr('d', arc2)
      .append('svg:title') // TITLE APPENDED HERE
      .text(function (d, i) {
        return data[i] + ' ' + label[i]
      })
  }

  return (
    <>
      <Row justify={'center'} style={{ textAlign: 'center', marginBottom: 10 }}>
        <Col onClick={handleclick}>
          <Button
            disabled={props.companyUser}
            type='primary'
            shape='round'
            size='small'
            style={{ fontSize: 12 }}
          >
            {props.data?.display_name}
          </Button>
        </Col>
      </Row>
      <Row
        justify={props.align ? props.align : 'center'}
        style={{ textAlign: 'center', minWidth: 140 }}
      >
        <Col flex={1} style={{ alignSelf: 'center', paddingRight: 10 }}>
          <svg ref={ref} width='60' height='60'></svg>
        </Col>
        <Col flex={3}>
          <Row style={{ color: CHART_COLORS.completeGreenSoft }}>
            <Col span={13} style={{ textAlign: 'left' }}>
              Complete
            </Col>
            <Col span={1}> : </Col>
            <Col span={10} style={{ textAlign: 'left' }}>
              {props.data?.devicesummary?.completeddays}
              {props.data?.completeddays == 1 ? ' Day' : ' Days'}
            </Col>
          </Row>
          <Row style={{ color: CHART_COLORS.partialYellow }}>
            <Col span={13} style={{ textAlign: 'left' }}>
              Partial
            </Col>
            <Col span={1}> : </Col>
            <Col span={10} style={{ textAlign: 'left' }}>
              {props.data?.devicesummary?.partialdays}
              {props.data?.partialdays == 1 ? ' Day' : ' Days'}
            </Col>
          </Row>
          <Row style={{ color: CHART_COLORS.skippedRed }}>
            <Col span={13} style={{ textAlign: 'left' }}>
              Skipped
            </Col>
            <Col span={1}> : </Col>
            <Col span={10} style={{ textAlign: 'left' }}>
              {props.data?.devicesummary?.incompletedays}
              {props.data?.incompletedays == 1 ? ' Day' : ' Days'}
            </Col>
          </Row>
          <Row style={{ color: '#aaaaaa' }}>
            <Col span={13} style={{ textAlign: 'left' }}>
              Remaining{' '}
            </Col>
            <Col span={1}> : </Col>
            <Col span={10} style={{ textAlign: 'left' }}>
              {props.data?.devicesummary?.remainingdays}
              {props.data?.remainingdays == 1 ? ' Day' : ' Days'}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default PatientBar
